exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cards[data-v-5bcf14d9]{list-style:none;padding:0 0 10px;margin-top:40px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-content:center;flex-wrap:wrap;width:100%;flex-grow:1}.countdown[data-v-5bcf14d9]{font-size:42px;color:#f89623}.game[data-v-5bcf14d9]{position:fixed;top:0;left:0;box-sizing:border-box;height:100vh;width:100vw;overflow:auto;z-index:20}.game[data-v-5bcf14d9],.game__body[data-v-5bcf14d9]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column}.game__body[data-v-5bcf14d9]{flex-grow:1;width:100%}", ""]);

// exports
